import Vue from "vue";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

if(PRODUCTION && typeof SENTRY_DSN !== 'undefined') {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
  // myUndefinedFunction();
}
